/**
 * 自定义查询 - 组件入口
 *
 * 仅导出轻量函数/常量：入口本身不静态引入任何 .vue 组件，
 * 页面组件均由 routes.js 通过动态 import 代码分割，按需加载（避免打入宿主主包、降低构建内存）。
 *
 * 宿主用法（零路由配置）：
 *   import { openCustomQuery } from '_c/custom-query'
 *   openCustomQuery(this.$router, { mark })
 * 可选注入真实接口（默认 mock）：
 *   import { setCustomQueryApi } from '_c/custom-query'
 *   setCustomQueryApi({ ...realApi })
 *
 * 如需按需使用视图组件（自行组页/一体化内部切换），请直接从子路径引入：
 *   import CustomQuery from '_c/custom-query/custom-query.vue'
 *   import QueryConfig from '_c/custom-query/views/query-config.vue'
 */
import { openCustomQuery, ensureCustomQueryRoutes } from './routes';
import { setCustomQueryApi, getCustomQueryApi, setStore, ROUTE_NAMES } from './runtime';
import mockApi from './api/mock-api';

// 默认导出「打开新页面」入口
export default openCustomQuery;

export { openCustomQuery, ensureCustomQueryRoutes, ROUTE_NAMES, setCustomQueryApi, getCustomQueryApi, setStore, mockApi };


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/custom-query/index.js
// module id = 79
// module chunks = 0